module.exports = __webpack_public_path__ + "img/web.24e3281d.png";